import React, { Component } from 'react';
import Header from '../../molecules/Header';
import Footer from '../../molecules/Footer';

/**
 * メール配信設定 完了画面
 */
class MailDeliveryUnsubscribed extends Component<any, any> {
  render() {
    return (
      <div>
        <Header />
        <div className='md-container'>
          <h2 className='md-headline' data-testid-e2e='mail-unsubscribe-done-text'>
            メールの配信を停止しました
          </h2>
          <p className='md-text'>配信を再開したい場合は、店頭でお手続きをお願いいたします。</p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default MailDeliveryUnsubscribed;
